import { JsonClassSerializer } from '@sumbricht/json-class-serializer'
import { commonJsonMapperOptions } from './json-mapper.js'
import { MappableLgClasses } from '../classes.js'

export const lgJsonMapper = new JsonClassSerializer({
	...commonJsonMapperOptions,
	failIfRootClassNotFound: false,
	additionalClassesToConsider: MappableLgClasses,
})

export const allowPlainObjectJsonMapper = new JsonClassSerializer({
	...commonJsonMapperOptions,
	failIfRootClassNotFound: false,
	failIfTypeResolutionFails: false,
	additionalClassesToConsider: MappableLgClasses,
})

export const boJsonMapper = new JsonClassSerializer({
	...commonJsonMapperOptions,
	failIfRootClassNotFound: true,
	prettyPrint: true,
	additionalClassesToConsider: MappableLgClasses,
})
